import React, { useState, useEffect, useRef, useMemo , useCallback} from 'react';
import { connect } from 'react-redux';
import Header from './Layout/Header';
import firebaseApp from '../Config/firebaseConfig';
import { getDatabase, ref, onValue, get, onChildChanged,goOffline } from 'firebase/database';
import {allLocationWithShortName} from './Helpers/util.js';
import { dataUser } from './Helpers/util';
import moment from 'moment';
import mixpanel from 'mixpanel-browser';
import axios from 'axios';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const locationWithShortName = allLocationWithShortName();
function SkyWatch({ onCompleteData }) {
  const [data, setData] = useState();
  const [selectedDevice, setSelectedDevice] = useState('1');
  const [locationName, setLocationName] = useState('');
  const [locationHumidity, setLocationHumidity] = useState('');
  const [locationTemperature, setLocationTemperature] = useState('');
  const [status, setStatus] = useState('');
  const [lastUpdated, setLastUpdated] = useState('');
  const [onlineCount, setOnlineCount] = useState();
  const [offlineCount, setOfflineCount] = useState();
  const [deviceArray, setDeviceArray] = useState([]);
  const [selectedId, setSelectedId] = useState('1');
  const mapRef = useRef(new Map());
  const [location, setLocation] = useState([]);
  const calculateAverage = useCallback((data, property) => {
    if (!data || !Array.isArray(data) || data.length === 0) return 0;
    const total = data.reduce((acc, item) => {
      if (item?.tempData && item?.tempData[property] != null) {
        acc += item?.tempData[property];
      }
      return acc;
    }, 0);
    return total / data.length;
  }, []);
  const getLocationNameById = useCallback(loc => {
    const locationShort = JSON.parse(locationWithShortName);
    const allLocations = locationShort;
    const locationData1 = allLocations?.find(obj => obj.rec_id == loc);
    return locationData1 ? locationData1.location_short_code : '';
  }, []);

  const addToMap = useCallback(
    (dataObj, loc) => {
      const locationName = getLocationNameById(loc);
      if (!dataObj) return;
      const map = new Map();
      for (let key of Object.keys(dataObj)) {
        const data = dataObj[key];
        data.details.center = locationName;
        map.set(data.details.deviceId, data);
      }
      setDeviceArray([...map.values()]);
    },
    [getLocationNameById],
  );
  const updateMap = useCallback(
    (key, obj, loc) => {
      const locationName = getLocationNameById(loc);
      obj.details.center = locationName;
      const map = new Map(mapRef.current);
      map.set(obj.details.deviceId, obj);
      // setDeviceArray([...map.values()]);
    },
    [getLocationNameById],
  );

  const getLocationBySpoc = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const params = {
      params: { spoc: UserObj?.rec_id, client: UserObj?.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      },
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          const rec_id = res.data.data.map(item => item.rec_id);
          setLocation(rec_id);
        }
      });
  };

  useEffect(() => {
    getLocationBySpoc();
  }, []);
  useEffect(() => {
    if (location.length > 0) {
      if (!firebaseApp) return;
      const db = getDatabase(firebaseApp);
      const unsubscribeFunctions = [];
      const localData = JSON.parse(localStorage.getItem('headData'));
      const company_id = localData?.com_rec_id;
      location.forEach(loc => {
        const dataRef = ref(
          db,
          `${process.env.REACT_APP_FIREBASE_ENV}/TS/${loc}/${company_id}`,
        );
        // Fetch initial data
        get(dataRef).then(snapshot => addToMap(snapshot.val(), loc));
        // Real-time listener
        const unsubscribe = onChildChanged(dataRef, snapshot => {
          updateMap(snapshot.key, snapshot.val(), loc);
        });
        unsubscribeFunctions.push(unsubscribe);
      });
      mixpanel.track('Skywatch firebase', {
        PageName: 'Skywatch firebase',
      });
      return () => {
        unsubscribeFunctions.forEach(unsub => unsub());
      };
    }
  }, [location]);

  const onlineOfflineCounts = useMemo(() => {
    let online = 0,
      offline = 0;
    deviceArray.forEach(item => {
      if (item.state?.isOnline) online++;
      else offline++;
    });
    return { online, offline };
  }, [deviceArray]);
  useEffect(() => {
    setOnlineCount(onlineOfflineCounts.online);
    setOfflineCount(onlineOfflineCounts.offline);
  }, [onlineOfflineCounts]);

  useEffect(() => {
    if (deviceArray) {
      if (deviceArray?.length === 1) {
        const singleDevice = deviceArray[0];
        const deviceName = singleDevice?.details?.deviceName;
        setSelectedDevice(deviceName);
        setLocationName(singleDevice?.details?.center);
        setLocationHumidity(
          singleDevice?.tempData?.relativeHumidity?.toFixed(2),
        );
        setLocationTemperature(singleDevice?.tempData?.temperature?.toFixed(1));
        const receivedDateTime = moment(
          singleDevice?.tempData?.updatedAt,
        ).format('h:mm A, Do MMMM YYYY');
        const minutesDifference = moment().diff(receivedDateTime, 'minutes');
        const newStatus = singleDevice?.state?.isOnline ? 'Online' : 'Offline';
        setStatus(newStatus);
        setLastUpdated(receivedDateTime);
      } else {
        if (selectedDevice === '1') {
          const avgHumidity = calculateAverage(deviceArray, 'relativeHumidity');
          const avgTemperature = calculateAverage(deviceArray, 'temperature');
          setLocationName('All Devices');
          setLocationHumidity(avgHumidity?.toFixed(2));
          setLocationTemperature(avgTemperature?.toFixed(1));
        } else {
          // const map = mapRef.current;
          // const selectedDeviceData = map.get(selectedDevice)
          const selectedDeviceData = deviceArray?.find(
            item => item?.details?.deviceId === selectedId,
          );
          if (selectedDeviceData) {
            setLocationName(selectedDeviceData?.details?.center);
            setLocationHumidity(
              selectedDeviceData?.tempData?.relativeHumidity?.toFixed(2),
            );
            setLocationTemperature(
              selectedDeviceData?.tempData?.temperature?.toFixed(1),
            );
            const receivedDateTime = moment(
              selectedDeviceData?.tempData?.updatedAt,
            ).format('h:mm A, Do MMMM YYYY');
            const minutesDifference = moment().diff(
              receivedDateTime,
              'minutes',
            );
            const newStatus = selectedDeviceData?.state?.isOnline
              ? 'Online'
              : 'Offline';
            setStatus(newStatus);
            setLastUpdated(receivedDateTime);
          }
        }
      }
    }
  }, [selectedDevice, deviceArray]);

  const formatDateTime = inputDateTime => {
    const dateTime = moment(inputDateTime, 'YY/MM/DD,HH:mm:ss');
    const formattedDate = dateTime.format('h:mm A, Do MMMM YYYY');
    return formattedDate;
  };

  // const handleDeviceChange = useCallback((event) => {
  // const deviceId = event.target.value;
  // setSelectedId(deviceId);
  // if (deviceId === "1") {
  // setSelectedDevice("1");
  // } else {
  // const selectedDevice = deviceArray.find(item => item?.details?.deviceId === deviceId);
  // if (selectedDevice) setSelectedDevice(selectedDevice);
  // }
  // }, [deviceArray]);

  const handleDeviceChange = useCallback(
    event => {
      const deviceId = event.target.value;
      setSelectedId(deviceId);
      if (deviceId === '1') {
        setSelectedDevice('1');
      } else if (Array.isArray(deviceArray) && deviceArray.length > 0) {
        const selectedDevice = deviceArray?.find(
          item => item?.details?.deviceId === deviceId,
        );
        if (selectedDevice) {
          setSelectedDevice(selectedDevice);
        } else {
          console.warn('No matching device found for deviceId:', deviceId);
        }
      } else {
        console.error(
          'deviceArray is not valid or has insufficient data:',
          deviceArray,
        );
      }
    },
    [deviceArray],
  );

  useEffect(() => {
    let onlineCount = 0;
    let offlineCount = 0;

    if (deviceArray) {
      deviceArray.forEach(item => {
        // const receivedDateTime = moment(item.rec_time, "YY/MM/DD,HH:mm:ss");
        // const minutesDifference = moment().diff(receivedDateTime, 'minutes');
        const status = item.state?.isOnline ? 'Online' : 'Offline';
        if (status === 'Online') {
          onlineCount++;
        } else {
          offlineCount++;
        }
      });
    }
    setOnlineCount(onlineCount);
    setOfflineCount(offlineCount);
  }, [deviceArray]);

  return (
    <>
      <div className="CollabCards_Container skywatchCardContainer">
        <div className="CardHead">
          <h2>Skywatch</h2>
          <div className="SkywachStatus">
            <div className="SkywachSTS">
              {selectedDevice === '1' ? (
                <>
                  {offlineCount > 0 ? (
                    <>
                      <div className={`STS_Dot offline`}>&nbsp;</div>
                      <div>{offlineCount} Offline</div>
                    </>
                  ) : (
                    ''
                  )}
                  &nbsp;&nbsp;
                  {onlineCount > 0 ? (
                    <>
                      <div className={`STS_Dot online`}>&nbsp;</div>
                      <div>{onlineCount} Online</div>
                    </>
                  ) : (
                    ''
                  )}
                </>
              ) : (
                <>
                  <div
                    className={`STS_Dot ${
                      status === 'Online' ? 'online' : 'offline'
                    }`}
                  >
                    &nbsp;
                  </div>
                  <div>{status}</div>
                </>
              )}
            </div>

            {selectedDevice === '1' &&
            deviceArray &&
            deviceArray?.length > 0 ? (
              <div className="LastUpdated">
                Last updated:{' '}
                {moment(
                  deviceArray[deviceArray?.length - 1]?.tempData?.updatedAt,
                ).format('h:mm A, Do MMMM YYYY')}
              </div>
            ) : (
              <div className="LastUpdated">Last updated: {lastUpdated}</div>
            )}
          </div>
        </div>
        <div className="CollabCards_body">
          <div className="CollabCard skywatchCard">
          <div className="skywatchDetails">
                <div className="DetailLabelRow">
                  {selectedDevice !== '1' && (
                    <>
                      <div className="DetailLabel">
                        <img
                          src="img/new-dashboard/location-icon.svg"
                          className="iconIMG"
                          alt=""
                        />
                        <div>Location:</div>
                      </div>
                      <div className="DetailName">
                        {locationName || 'No Location Name'}
                      </div>
                    </>
                  )}
                </div>

                {deviceArray && deviceArray?.length > 0 ? (
                  <div className="DetailLabelRow">
                    <div
                      className="DetailLabel"
                      style={{ marginBottom: '0px' }}
                    >
                      <img
                        src="img/new-dashboard/device-icon.svg"
                        className="iconIMG"
                        alt=""
                      />
                      <div>Device:</div>
                    </div>
                    <select
                      className="DeviceSelect"
                      value={selectedId}
                      onChange={handleDeviceChange}
                    >
                      <option value="1">All Devices</option>
                      {deviceArray.map((item, index) => (
                        <option key={index} value={item?.details?.deviceId}>
                          {item?.details?.deviceName}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : (
                  // Otherwise, just display the device name
                  <div className="DetailLabelRow">
                    <div className="DetailLabel">
                      <img
                        src="img/new-dashboard/device-icon.svg"
                        className="iconIMG"
                        alt=""
                      />
                      <div>Device:</div>
                    </div>
                    <div className="DetailName">
                      {selectedDevice || 'No device selected'}
                    </div>
                  </div>
                )}
              </div>
              <div className="skywatch_wheatherCards">
                <div className="wheatherCards">
                  <div className="wheatherLabel">
                    <div className="wheatherLabelIcon">
                      <img
                        src="img/new-dashboard/humidity-icon.svg"
                        className="iconIMG"
                        alt=""
                      />
                    </div>
                    <div>
                      {selectedDevice === '1' ? 'Avg. Humidity' : 'Humidity'}
                    </div>
                  </div>
                  <div className="wheatherResult">
                    <div>{locationHumidity} %</div>
                    <div className="FeelsLike" />
                  </div>
                </div>
                {locationTemperature < 25 ? (
                  <div className="wheatherCards ">
                    <div className="wheatherLabel">
                      <div className="wheatherLabelIcon">
                        <img
                          src="img/new-dashboard/temperature-icon.svg"
                          className="iconIMG"
                          alt=""
                        />
                      </div>
                      <div>
                        {selectedDevice === '1' ? 'Avg. Temp.' : 'Temperature'}
                      </div>
                    </div>
                    <div className="wheatherResult">
                      <div>
                        {locationTemperature}
                        <span>&deg;c</span>
                      </div>
                      <div className="FeelsLike">Feels cool</div>
                    </div>
                  </div>
                ) : (
                  <div className="wheatherCards wheatherCards_Moderate ">
                    <div className="wheatherLabel">
                      <div className="wheatherLabelIcon">
                        <img
                          src="img/new-dashboard/temperature-icon.svg"
                          className="iconIMG"
                          alt=""
                        />
                      </div>
                      <div>
                        {selectedDevice === '1' ? 'Avg. Temp.' : 'Temperature'}
                      </div>
                    </div>
                    <div className="wheatherResult">
                      <div>
                        {locationTemperature}
                        <span>&deg;c</span>
                      </div>
                      <div className="FeelsLike">Feels Warm</div>
                    </div>
                  </div>
                )}
              </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect()(SkyWatch);
